import { Trans, useLingui } from '@lingui/react/macro';
import { Lock } from 'lucide-react';
import React from 'react';

import { Pages } from 'modules/navigation/domain/enums/pages';
import UDLink from 'ud-ui/components/link';
import { useFeature } from 'shared/hooks/use-feature';

/** Фича тарифа, которой закрыта инструкция: видеометки ставит табло OBS/vMix, закрытое ею же. */
export const VIDEO_MARKERS_GUIDE_FEATURE = 'OBS_INTEGRATION';

/**
 * Ссылка «Как настроить OBS и vMix». Без фичи ведёт на вкладку «Подписка» и несёт замок —
 * тот же значок и подпись, что у платного пункта меню (`menu-item.tsx`), чтобы закрытый
 * раздел выглядел одинаково везде ([PAID]).
 */
export default function VideoMarkersGuideLink() {
  const { isEnabled, isFetching } = useFeature(VIDEO_MARKERS_GUIDE_FEATURE);
  const { t } = useLingui();
  const isLocked = !isFetching && !isEnabled;

  if (isLocked) {
    return (
      <UDLink
        to={Pages.SETTINGS.builders.subscription(VIDEO_MARKERS_GUIDE_FEATURE)}
        type="footnote"
        className="inline-flex items-center gap-1"
      >
        <Trans>Как настроить OBS и vMix</Trans>
        <Lock size={14} aria-label={t`Платный раздел`} />
      </UDLink>
    );
  }

  return (
    <UDLink to={Pages.DEVICES.VIDEO_MARKERS_GUIDE} type="footnote">
      <Trans>Как настроить OBS и vMix</Trans>
    </UDLink>
  );
}
